document.addEventListener("DOMContentLoaded", function () {
  const historySection = document.querySelector("#history-section");

  // Exit early if the section isn't found
  if (!historySection) return;

  /**
   * Use event delegation to intercept all pagination clicks.
   * This is necessary because the pagination elements get replaced on each fetch.
   */
  historySection.addEventListener("click", function (e) {
    // Look for a pagination <a> tag that was clicked inside .custom-pagination
    const link = e.target.closest(".custom-pagination a");

    // Exit if it's not a valid pagination link
    if (!link || !link.href) return;

    e.preventDefault();

    // Optionally disable all pagination links to prevent double-clicking
    const paginationLinks = historySection.querySelectorAll(
      ".custom-pagination a"
    );
    paginationLinks.forEach((link) => link.classList.add("disabled"));
    const loader = historySection.querySelector(
      ".order-history-loading-overlay"
    );
    const ohSpinner = document.getElementById("ohSpinner");

    if (loader) loader.hidden = false;
    ohSpinner.style.display = "inline-flex";

    fetch(link.href)
      .then((res) => res.text())
      .then((html) => {
        // Parse the HTML response to extract the updated #history-section content
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newSection = doc.querySelector("#history-section");

        // Safety check: ensure the new section exists
        if (!newSection) throw new Error("Pagination target not found!");

        // Replace current section content with the new one from the fetched page
        historySection.innerHTML = newSection.innerHTML;

        // Optional: Scroll to top of section again if needed
        // historySection.scrollIntoView({ behavior: "smooth", block: "start" });

        /**
         * Re-bind modal button events.
         * Since we replaced the DOM, event listeners on <a onclick="..."> buttons are lost.
         */
        const newPDFButtons = historySection.querySelectorAll(
          '[onclick^="openModal"]'
        );
        newPDFButtons.forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            openModal("view-pdf", e.currentTarget);
          });
        });

        // Update browser URL using History API to reflect the new pagination state
        history.pushState(null, "", link.href);
      })
      .catch((err) => {
        console.error("Pagination error:", err);
      })
      .finally(() => {
        paginationLinks.forEach((link) => link.classList.remove("disabled"));
        if (loader) loader.hidden = true;
        ohSpinner.style.display = "none";
      });
  });
});
